<div class="file-upload d-flex flex-column justify-content-center align-items-center">
  <p *ngIf="!selectedFile" class="file-upload-notice text-danger">{{ "uploadFile.notice" | cxTranslate }}</p>
  <button class="c-button c-button--primary mb-2">
    <form [formGroup]="myForm" >
      <input
        type="file"
        name="file"
        id="file"
        (change)="onFileChanged($event)"
        formControlName="file"
        accept=".pdf,.eml,.doc,.docx">
        <label for="file" *ngIf="!selectedFile"> {{ "uploadFile.buttonText" | cxTranslate }}</label>
        <label for="file" *ngIf="selectedFile"> {{ "uploadFile.uploadAnotherFile" | cxTranslate }}</label>
        
    </form>
  </button>
  <p class="file-name" *ngIf="selectedFile">{{selectedFile.name}}</p>
</div>